import { Component, Inject } from '@angular/core';
import { ISitemap, SITEMAP } from 'pbc.angular';
import { IFilterConfig, ISelection } from 'pbc.types';

import get from 'lodash/get';
import { Subscription } from 'rxjs';

import { ITourResponse, TourQueryFilterConfig } from 'fa-kt.types';
import { TourService } from '../service';

@Component({
  selector: 'fa-kt-tour-filter',
  templateUrl: './tour-filter.component.html',
  styleUrls: ['./tour-filter.component.css'],
})
export class TourFilterComponent {
  readonly subscriptions: Subscription[] = [];

  public TourFilterConfig: IFilterConfig<ITourResponse>;

  constructor(
    @Inject(SITEMAP) private sitemap: ISitemap,
    public tour: TourService,
  ) {
    this.TourFilterConfig = TourQueryFilterConfig.map((filter) => ({ ...filter, title: get(sitemap, filter.title, filter.title) as string }));
  }

  ngOnInit() {
    this.subscriptions.push();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(($) => $.unsubscribe());
  }

  private shape(field: string, shapes: ISelection[]): void {
    const index = this.TourFilterConfig.findIndex((f) => f.key === field);
    if (index < 0) {
      return;
    }
    this.TourFilterConfig[index].selections = shapes;
  }
}
